var map = {
	"./logo-OST2-m.png": 592,
	"./logo-OST2.png": 593,
	"./logo-Sync2-Cloud-m.png": 594,
	"./logo-Sync2-Cloud.png": 595,
	"./logo-duplicate-killer-m.png": 596,
	"./logo-duplicate-killer.png": 597,
	"./logo-ostpstviewer-m.png": 598,
	"./logo-ostpstviewer.png": 599,
	"./logo-outlook-duplicate-remover-m.png": 600,
	"./logo-outlook-duplicate-remover.png": 601,
	"./logo_SPB.png": 602,
	"./undefined.png": 603
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 591;